import { Stack, TextField } from "@shopify/polaris";
import React from "react";
import { ComponentLabelPolaris } from "../../shared/ComponentLabelPolaris";

const errMsg = {
  apiKey: "Store URL is required",
};

function PrintwayFCImpl({ apiKey }, forwardedRef) {
  const [state, setState] = React.useReducer((p, s) => ({ ...p, ...s }), {
    apiKey: "",
    storeID: "",
    error: {},
  });

  const handleValidate = React.useCallback(
    (value, id, prevError) => {
      let err = "";
      if (!value) {
        err = errMsg[id];
      }
      const newError = { ...prevError, [id]: err };
      setState({ error: newError });
      return newError;
    },
    [state.error],
  );

  const handleChange = React.useCallback((value, id) => {
    setState({ [id]: value });
  }, []);

  const handleSubmit = React.useCallback(() => {
    handleValidate(state.apiKey, "apiKey");
    if (state.apiKey && state.storeID) {
      return {
        apiKey: state.apiKey,
        storeID: state.storeID,
      };
    }
  }, [state.apiKey, state.storeID, handleValidate]);

  React.useImperativeHandle(forwardedRef, () => ({ onSubmit: handleSubmit }));

  return !apiKey ? (
    <Stack vertical spacing="tight">
      <div>
        <ComponentLabelPolaris label="Api Key" required />
        <TextField
          value={state.apiKey}
          onChange={handleChange}
          placeholder="Enter API Key"
          id="apiKey"
        />
      </div>
      <TextField
        value={state.storeID}
        onChange={handleChange}
        placeholder="Enter store code"
        id="storeID"
        label="Store"
      />
    </Stack>
  ) : null;
}

const PrintwayFC = React.forwardRef(PrintwayFCImpl);
export default PrintwayFC;
